import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../store/actions';
import { getShiftEmployee } from '../store/selectors';
import { ShiftRemoveCustomModal as Component } from './ShiftRemoveCustomModal';

const mapStateToProps = ({ shifts }, { employeeId }) => ({
  employee: getShiftEmployee(shifts, { employeeId }),
  datePickerRange: shifts.datePickerRange,
  isSavingShift: shifts.isSavingShift,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export const ShiftRemoveCustomModal = connect(mapStateToProps, mapDispatchToProps)(Component);
